/* eslint-disable react/no-unescaped-entities */
import React from 'react';

import { Typography, Box } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';

type Props = {
  open: boolean;
};

const CCIAlertBottomBar: React.FC<Props> = ({ open }) => {
  const barHeight = 76;
  return (
    <MuiAppBar
      position='fixed'
      color='darkBlue'
      sx={(theme) => ({
        top: 'auto',
        bottom: `-${barHeight}px`,
        flex: 1,
        px: 0,
        justifyContent: 'center',
        transition: theme.transitions.create(['margin', 'height'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
          height: barHeight,
          marginBottom: `${barHeight}px`,
          transition: theme.transitions.create(['margin', 'height'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      })}
    >
      <Box
        sx={{
          height: barHeight,
          backgroundColor: 'darkBlue.main',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          justifySelf: 'flex-end',
        }}
      >
        <Typography fontSize='18px' color='white'>
          Incorrect CCI code combination!
        </Typography>
        <Typography fontSize='12px' color='white'>
          Hover over a code's error icon to view conflicts
        </Typography>
      </Box>
    </MuiAppBar>
  );
};

export default CCIAlertBottomBar;
